import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Menu } from '@components/base';
import { ImageType } from '@models/Image';

import useDownloadImage from './useDownloadImage';

export type DownloadImageMenuItemProps = {
  fileNameBase: string;
  imageType: ImageType;
  src: string;
};

const DownloadImageMenuItem: FC<DownloadImageMenuItemProps> = ({
  fileNameBase,
  imageType,
  src,
}) => {
  const { t } = useTranslation();
  const { downloadImage, loading } = useDownloadImage(fileNameBase, imageType, src);

  return (
    <Menu.Item
      disabled={loading}
      icon={<Icon name='download' />}
      keepMounted
      onClick={downloadImage}
    >
      {t('download')}
    </Menu.Item>
  );
};

export default DownloadImageMenuItem;
